module.exports = {
  储值中心: '충전센터',
  角色信息: '캐릭터 정보',
  '角色：': '캐릭터：',
  '区服：': '서버：',
  '游戏：': '게임：',
  '商品：': '상품명：',
  支付方式: '결제 수단',
  '结算：': '계산：',
  '订单金额：': '주문금액：',
  '支付金额：': '결제금액：',
  确认支付: '결제 확인',
  请选择支付方式: '결제 방식을 선택하십시오',
  '注意：支付金额请以实际支付时为准':
    '주의: 지불 금액은 실제 지불 시의 금액 기준으로 합니다.',
  '订单号：': '주문번호：',
  '时间：': '주문일자：',
  '支付方式：': '결제 방식：',
  '钱包：': '캐시백：',
  '订单状态：': '주문 상태：',
  '说明：': '설명：',
  '如有疑问，请联系客服cshw@ijunhai.com':
    '문의사항 있으시면 고객센터 이메일 cskr@itrigirls.com에 연락해 주시기 바랍니다.',
  支付失败: '결제 실패했습니다. ',
  购买中: '구매중 ',
  支付成功: '결제 성공',
  购买成功: '구매 성공. ',
  购买失败: '구매 실패',
  unknow: 'unknow',
  全部: '전부',
  下拉更新: '풀다운 갱신',
  松开更新: '놓고 갱신',
  更新中: '갱신 중',
  '加载中……': '로딩중……',
  暂无数据: '데이터 없음',
  支付完成: '지급 완료',
  '请在游戏内查收道具。如需帮助，可以联系我们的客服':
    '결제하신 상품을 확인해 주시기 바랍니다. 도움이 필요하시면 고객센터에 문의 접수해주세요.',
  结束充值: '충전 완료',
  '没有记录哦~': '기록 없음',
  '卡号：': '카드번호：',
  '密码：': '비밀번호：',
  储值记录: '결제 기록',
  '可用余额：': '잔액：',
  T币: 'T코인',
  账号信息: '계정 정보',
  '用户ID：': '아이디：',
  账号注销: '계정 삭제',
  修改密码: '비밀번호 변경',
  旧密码: '기존 비밀번호',
  '新密码（6-20位字符）': '신규 비밀번호(6-20자)',
  为了您的账户安全: '계정 안전적인 사용을 위해',
  '请联系客服人员进行再次确认：cshw@iijunhai.com':
    '고객센터 이메일 cskr@itrigirls.com로 문의하시고 다시 확인해 주시기 바랍니다',
  确定: '확인',
  '使用以下方式完成储值，额外获赠': '해당 방식들로 결제하면 추가증정의',
  元宝: '황금을 획득합니다.',
  你已完成储值: '결제 완료',
  '储值失败，请重试': '결제 실패, 다시 시도하세요.',
  选择支付方式: '결제 방식 선택',
  '完成储值，额外获赠': '결제 완료, 추가증정의',
  '余额不足，剩余': '잔액 부족, 진액',
  信用卡: '신용 카드',
  点卡: '문화상품권',
  银行转账: '은행 카드',
  立即支付: '구매하기',
  返回游戏: '게임 돌아감',
  mol: 'Razer',
  请选择: '선택하세요',
  返回首页: '홈페이지로 돌아가기',
  '如需帮助，请联系我们的邮箱：':
    '도움이 필요하시면 공식 이메일로 연락하시기 바랍니다.',
  继续充值: '다시 충전',
  '选择区服/角色': '서버/캐릭터 선택',
  确认付款: '결제 확인',
  充值商品: '주문 상품',
  商品赠送: '상품 증정',
  实际支付: '실제결제',
  立即充值: '충전하기',
  支付确认: '주문확인',
  '请确认是否支付完成？': '결제완료되었습니까?',
  继续支付: '계속 결제',
  取消支付: '결제 취소',
  用户协议: '이용 약관',
  隐私协议: '개인 정보 처리 방침',
  游戏账号删除协议: '계정 삭제 이용약관',
  账号删除进程: '계정 삭제 진도',
  '我们为您做出如下特别说明：在删除本游戏的游戏账号后，除法律法规或本协议另有规定外，您在该游戏账号下的个人信息将进行删除或匿名化处理，且此前已关联该游戏账号的相关产品与服务将不再关联。该游戏账号一旦删除完成，将无法恢复，您无法再检索、继续使用、访问和召回，也无权要求我们找回个人信息，请您谨慎操作。前述个人信息包括但不限于头像、昵称、会员权益、等级/经验值等与游戏角色成长升级相关的所有数据、虚拟货币、虚拟道具等虚拟物品、聊天记录等内容。': '본게임의 계정 삭제 후 법적이나 본 약관에 특별한 규정이 있는 경우를 제외하고는 해당 게임 계정에서 귀하의 개인 정보를 삭제 또는 익명화 처리하며, 해당 계정과 연계되어 있던 상품과 서비스는 더 이상 연관되지 않음을 특별히 안내해 드립니다. 본 계정은 한번 삭제가 완료되면 복구가 불가능하며, 더 이상 검색, 사용, 방문 및 리콜이 불가능하며, 개인 정보를 되찾을 수 없으므로 주의하여 주시기 바랍니다. 상기 개인 정보에는 프로필 사진, 닉네임, 회원 권익, 등급/경험치 등 게임 캐릭터와 관련된 모든 데이터, 가상화폐, 가상 아이템 등 가상 물, 채팅 기록 등의 내용이 포함됩니다.',
  '1、账号必须事先绑定邮箱。删除账号需要用邮箱进行验证，确保是本人操作。': '1. 계정은 반드시 사전에 이메일 연동이 완료되어야 합니다. 본인 확인하기 위해 계정 삭제 시 이메일을 통해 인증해야 합니다.',
  '2、游戏收益已结清或得到妥善处理：包括但不局限于游戏代币、道具、会员权益等收益。请您妥善处理，若未处理，视为您自愿放弃该等收益。': '2. 게임 수익이 청산되었거나 선처되어야 합니다.(게임 화폐, 아이템, 회원 권익 등을 포함) 미처리 시 자발적으로 수익을 포기한 것으로 간주합니다.',
  '3、账号无任何纠纷：包括投诉举报、被投诉举报、仲裁、诉讼等纠纷。': '3. 계정에는 어떠한 분쟁도 없어야 합니다. (민원신고, 중재, 소송 등 분쟁 포함)',
  '亲爱的玩家，在您正式开始下一步有关本游戏的删除游戏账号流程前，请您务必先行仔细阅读、充分理解并同意《删除游戏账号协议》（以下统称“本协议”）。您按照游戏内提示的删除游戏账号之操作流程进行删除账号申请或开始删除账号流程的，或者您勾选本删除游戏账号协议并开始下一步操作的，均视为您已经同意和遵守本协议全部内容。': '사랑하는 유저님, 본 게임과 관련된 계정 삭제 절차를 본격적으로 시작하기 전에 반드시 <게임 계정 삭제 이용약관>을 읽고 동의하셔야 합니다. 게임 내 제시된 삭제 절차에 따라 계정 삭제 신청을 하거나 계정 삭제 프로세스를 시작하거나, <게임 계정 삭제 이용약관>을 체크하고 다음 절차를 시작하는 경우, 본 약관의 모든 내용을 동의한 것으로 간주됩니다.',
  有关删除游戏账号的其它详细规则及注意事项请点击查看: '게임 계정 삭제에 관한 자세한 규칙 및 주의사항 보기:',
  删除游戏账号协议: '게임 계정 삭제 이용약관',
  '将删除的游戏账号：': '삭제할 게임 계정',
  游戏账号: '게임 계정',
  游戏ID: '게임 ID',
  失败原因: '실패 원인',
  '亲爱的用户，为确保您的账号安全，请提供您账号绑定的邮箱验证码以供账号删除校验，该验证码仅用于本次验证使用': '사랑하는 유저님, 계정 보안을 위해, 계정 삭제 확인 시 계정과 연동된 휴대폰에 받으신 인증번호를 입력하셔야 합니다. 인증번호는 이번 인증에서만 사용됩니다.',
  邮箱: '이메일',
  验证码: '인증번호',
  请输入验证码: '확인 코드를 입력',
  获取验证码: '얻다',
  请描述你除账号的原因: '계정을 삭제할 이유는 무엇입니까?',
  '为防止误操作，请您再次确认是否删除游戏账号并确认删除后的影响，该影响包括但不限于（具体详见：': '실수를 방지하기 위하여 게임 계정 삭제 여부와 삭제 후 발생한 영향을 다시 한번 확인해 주세요. 이 영향은 포함하여 한정되지 않습니다.(자세한 내용은 아래 참고)',
  '1.该账号一旦删除成功，您将无法登录、使用该游戏账号，且无法回复。除法律法规和《删除游戏账号协议》另有约定外，您在该游戏账号下的个人信息将进行删除或匿名化处理，且此前已关联该游戏账号的相关产品与服务将不再关联。该游戏账号一旦删除完成，将无法恢复，您无法再检索、继续使用、访问和召回，也无权要求我们找回个人信息，请您谨慎操作。': '1. 해당 계정이 삭제되면 해당 게임 계정을 로그인 및 사용할 수 없으며, 회신할 수 없습니다. 유저님의 개인 정보는 법률 및 규칙 그리고 <게임 계정 삭제 이용약관>이 따로 있는 경우를 제외하고는 삭제 또는 익명화되며, 기존에 해당 게임 계정과 연관되어 있던 상품 및 서비스는 더 이상 연관되지 않습니다. 본 계정은 한번 삭제가 완료되면 복구 불가능하며, 더 이상 검색, 계속 사용, 방문 및 소환이 불가능하며, 개인 정보를 되찾아 달라고 요청할 수 없으므로 주의하시기 바랍니다.',
  '2.您确认知悉，删除游戏账号的，该账号在本游戏使用期间已产生及未来可能产生是所有游戏收益或权益将会被全部删除/清除。据此，也特别提示您，在您开始删除本游戏账号前请您妥善处理您的游戏收益或权益。否则，账号删除后，我们有权利对该账号下的全部收益或权益做删除/清除处理，因此产生的后果由您自行承担，前游戏收益或权益包括但不限于账号内剩余的所有游戏虚拟货币、虚拟道具及其它虚拟物品及增值服务。': '2. 게임 계정은 삭제하는 것을 확인하시고, 해당 계정은 본 게임 이용 기간 동안 발생하였으며, 향후 발생할 수 있는 모든 게임 수익 또는 이익은 모두 삭제/삭제됨을 알려드립니다. 이에 따라, 본 게임 계정을 삭제하기 전에 게임 수익이나 이권을 선처하시기 바랍니다. 그렇지 않은 경우, 계정 삭제 후 해당 계정의 수익 또는 권익을 삭제/제거 처리가 가능하므로 유저님을 담당하셔야 합니다. 전 게임 수익 또는 권익은 계정 내에 포함되지만 이에 국한되지 않습니다. 나머지 모든 게임 가상화폐, 아이템 및 기타 가상 물 및 부가가치 서비스도 포함됩니다.',
  您的游戏角色将于: '귀하의 캐릭터는',
  '完成删除。请注意，该账号删除有15日的冷静期(账号锁定期)。除法律法规规定和协议约定情形外 我们将在冷静期满后完成删除，删除或匿名化处理您的个人信息。': '삭제가 완료됩니다. 해당 계정 삭제는 15일 동안 잠금 상태로 유지합니다. 법적 및 이용 약관에 언급된 경우 제외, 개인 정보는 잠금 기간 만료한 후 삭제 또는 익명화로 처리하도록 하겠습니다.',
  '在此期间，请您不要登录和使用该账号，以确保删除的顺利完成，否则视为您撤销删除申请。': '처리 시간 내에 계정 삭제가 원활하게 이루어질 수 있도록 계정을 접속하거나 사용하지 마세요. 그렇지 않을 경우 삭제 신청을 취하한 것으로',
  确认删除游戏账号: '삭제하기',
  放弃删除: '삭제 안 함',
  下一步: '다음',
  这是个多余的账号: '사용하지 않은 계정입나다.',
  弃游不想再玩: '더 이상 하고 싶지 않습니다.',
  需要换绑实名认证信息: '본인인증 정보를 바꾸셔야 합니다.',
  其他: '기타',
  我已详细阅读并满足删除账号条件: '이미 자세히 읽고 계정 삭제 조건에 만족한 것을 확인합니다.',
  确认删除的游戏账号: '삭제할 게임 계정 확인',
  我已详细阅读并同意: '네, 동의합니다.',
  验证本账号绑定的邮箱: '본 계정 연동된 이메일을 인증하기',
  选择删除的原因: '삭제 사유 선택',
  再次确认是否删除游戏账号并确认删除后的影响: '삭제 여부를 다시 확인하시기 바랍니다.',
  删除游戏账号申请提交成功: '게임 계정 삭제 요청 성공',
  完成: '완료',
  验证码发送成功: '인증번호가 발송되었습니다. 유의하시기 바랍니다.',
  '请先勾选【我已仔细阅读并满足账号删除条件】': '먼저 [이미 자세히 읽고 계정 삭제 조건에 만족한 것을 확인합니다]를 체크하세요.',
  '请先勾选【我已阅读并同意': '먼저 <게임 계정 삭제 이용약관>을 읽고 [네, 동의합니다]를 체크하세요.',
  账号删除申请失败: '계정 삭제 신청 실패',
  验证成功: '인증 성공',
  请选择删除原因: '삭제 사유를 선택하세요.',
  用户的游戏账号未绑定邮箱: '사용자의 게임 계정은 사서함에 바인딩되지 않습니다.',
  游戏账号删除条件: '게임 계정 삭제 조건',
  需要解绑邮箱: '이메일 바인딩 해제 필요',
  '请先勾选【我已阅读并同意《游戏账号删除协议》】': '먼저 <게임 계정 삭제 이용약관>을 읽고 [네, 동의합니다]를 체크하세요.',
};



// WEBPACK FOOTER //
// ./src/common/lang/ko.js